import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import OrderListItem from "./OrderListItem";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderList } from "../../actions/catalog";
import InfoBox from "../../components/Reusable/InfoBox";
import { t } from "i18next"; // Import t function for translation

const Order = () => {
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useDispatch();

  const { orderList } = useSelector((state) => state.catalogReducer);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  useEffect(() => {
    dispatch(fetchOrderList(activeTab));
  }, [dispatch, activeTab]);

  return (
    <div className="order-main-container">
      <Breadcrumb title={t("order.breadcrumbTitle")} returnPage="/" />

      <div className="order-list-container">
        <div className="user-order-category-items">
          <div
            className={`user-order-category-item ${
              activeTab === 0 ? "active" : ""
            }`}
            onClick={() => handleTabClick(0)}
          >
            {t("order.orderCategories.ordered")}
          </div>
          <div
            className={`user-order-category-item ${
              activeTab === 2 ? "active" : ""
            }`}
            onClick={() => handleTabClick(2)}
          >
            {t("order.orderCategories.approved")}
          </div>
          <div
            className={`user-order-category-item ${
              activeTab === 1 ? "active" : ""
            }`}
            onClick={() => handleTabClick(1)}
          >
            {t("order.orderCategories.rejected")}
          </div>
        </div>

        <div className="order-list-items">
          {orderList?.length > 0 ? (
            orderList?.map((item, key) => (
              <OrderListItem data={item} key={key} />
            ))
          ) : (
            <InfoBox text={t("order.noOrders")} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Order;
